import React from 'react';
import { FiArrowUp } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import aikoLogo from '../assets/logos/aiko-black.png';
import { handleSmoothScroll } from '../utils/scrollUtils';

const Footer = () => {
  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-white text-gray-700 pt-16 mt-24 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        {/* Footer top section with logo and columns */}
        <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-12 gap-8">
          
          {/* Logo and language column */}
          <div className="md:col-span-1 lg:col-span-3">
            <div className="flex flex-col space-y-4">
              <img src={aikoLogo} alt="Aiko" className="h-auto w-20" />
              <div className="flex items-center space-x-2 text-sm">
                <span className="inline-block w-5 h-3 rounded-sm relative overflow-hidden">
                  {/* Drapeau français : bleu, blanc, rouge */}
                  <div className="absolute inset-0 flex">
                    <div className="w-1/3 h-full bg-blue-600"></div>
                    <div className="w-1/3 h-full bg-white"></div>
                    <div className="w-1/3 h-full bg-red-600"></div>
                  </div>
                </span>
                <span>France (Français)</span>
              </div>
            </div>
          </div>
          
          {/* Services column */}
          <div className="md:col-span-1 lg:col-span-3">
            <h3 className="font-medium text-base mb-4">Nos services</h3>
            <ul className="space-y-2">
              <li><a onClick={(e) => handleSmoothScroll(e, 'services')} className="text-sm hover:text-indigo-600 transition-colors cursor-pointer">Sites internet</a></li>
              <li><a onClick={(e) => handleSmoothScroll(e, 'services')} className="text-sm hover:text-indigo-600 transition-colors cursor-pointer">Création de logo</a></li>
              <li><a onClick={(e) => handleSmoothScroll(e, 'services')} className="text-sm hover:text-indigo-600 transition-colors cursor-pointer">Hébergement</a></li>
              <li><a onClick={(e) => handleSmoothScroll(e, 'services')} className="text-sm hover:text-indigo-600 transition-colors cursor-pointer">Automatisation Make</a></li>
            </ul>
          </div>
          
          {/* Tarifs column */}
          <div className="md:col-span-1 lg:col-span-2">
            <h3 className="font-medium text-base mb-4">Tarifs</h3>
            <ul className="space-y-2">
              <li><a onClick={(e) => handleSmoothScroll(e, 'services')} className="text-sm hover:text-indigo-600 transition-colors cursor-pointer">Sites internet</a></li>
              <li><a onClick={(e) => handleSmoothScroll(e, 'services')} className="text-sm hover:text-indigo-600 transition-colors cursor-pointer">Création de logo</a></li>
              <li><a onClick={(e) => handleSmoothScroll(e, 'services')} className="text-sm hover:text-indigo-600 transition-colors cursor-pointer">Hébergement</a></li>
              <li><a onClick={(e) => handleSmoothScroll(e, 'services')} className="text-sm hover:text-indigo-600 transition-colors cursor-pointer">Automatisation</a></li>
            </ul>
          </div>
          
          {/* Technologies column */}
          <div className="md:col-span-1 lg:col-span-2">
            <h3 className="font-medium text-base mb-4">Technologies</h3>
            <ul className="space-y-2">
              <li><span className="text-sm text-gray-600">React</span></li>
              <li><span className="text-sm text-gray-600">JavaScript</span></li>
              <li><span className="text-sm text-gray-600">HTML/CSS</span></li>
              <li><span className="text-sm text-gray-600">Figma</span></li>
            </ul>
          </div>
          
          {/* Contact column */}
          <div className="md:col-span-1 lg:col-span-2">
            <h3 className="font-medium text-base mb-4">Contact</h3>
            <ul className="space-y-2">
              <li><a onClick={(e) => handleSmoothScroll(e, 'contact')} className="text-sm hover:text-indigo-600 transition-colors cursor-pointer">Nous contacter</a></li>
              <li><a onClick={(e) => handleSmoothScroll(e, 'contact')} className="text-sm hover:text-indigo-600 transition-colors cursor-pointer">Demander un devis</a></li>
              <li><a onClick={(e) => handleSmoothScroll(e, 'faq')} className="text-sm hover:text-indigo-600 transition-colors cursor-pointer">FAQ</a></li>
              <li>
                <a 
                  href="https://wa.me/33640886772" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-sm hover:text-indigo-600 transition-colors flex items-center"
                >
                  <FaWhatsapp className="text-green-500 mr-1" />
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Footer bottom section */}
        <div className="mt-16 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
          <div className="text-sm text-gray-500 mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Aiko. Tous droits réservés.
          </div>
          
          <div className="flex flex-wrap justify-center gap-4 md:gap-6">
            <a href="/#/confidentialite" className="text-sm text-gray-500 hover:text-indigo-600 transition-colors">Confidentialité</a>
            <a href="/#/mentions-legales" className="text-sm text-gray-500 hover:text-indigo-600 transition-colors">Mentions légales</a>
          </div>
        </div>
      </div>
      
      {/* Scroll to top button */}
      <motion.button
        onClick={scrollToTop}
        className="fixed bottom-6 right-6 w-12 h-12 rounded-full bg-[#5046E5] text-white flex items-center justify-center shadow-lg hover:bg-[#4038c2] transition-colors z-50"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <FiArrowUp />
      </motion.button>
    </footer>
  );
};

export default Footer;
